/* globals RTCSessionDescription */
'use strict';
module.exports = typeof RTCSessionDescription !== 'undefined'
  ? RTCSessionDescription
  : window.mozRTCSessionDescription;



//////////////////
// WEBPACK FOOTER
// ./~/@twilio/webrtc/lib/rtcsessiondescription/firefox.js
// module id = 93
// module chunks = 0